import React from 'react';

const Error = ({message = "Unknown error."}) => <span>{message}</span>;

export default Error;
